<template>
    <div class="home__cards">
      <ProductItem
          v-for="product in products.slice(0, 8)"
          :key="product.id"
          :product="product"
          :is-auth="isAuth"
          @add-to-cart="addToCart"
      />
    </div>
</template>

<script>
import ProductItem from './ProductItem.vue';
import axios from "axios";

export default {
  components: { ProductItem },
  data() {
    return {
      products: [],
      isAuth: window.IS_AUTHENTICATED || false,
    };
  },
  async mounted() {
    /*const query = {
      new: true,
      limit: '3',
      order_by: 'id'
    };*/
    const query = {
      product_collection: 'novinki-na-glavnoj',
      limit: '3',
    };

    try {
      const response = await axios.post('/api/products', query);
      this.products = response.data.products || [];
    } catch (error) {
      console.error('Error fetching new products:', error);
      this.products = [];
    }
  },
  methods: {
    /* переключение кнопки + вызов вашей функции */
    toggleManufacturer(value) {
      this.filters.manufacturer = this.filters.manufacturer === value ? null : value;
      this.fetchFilters(); // та же функция, что и у vs-select
    },
    toggleBrand(value) {
      this.filters.brand = this.filters.brand === value ? null : value;
      this.fetchFilters(); // та же функция, что и у vs-select
    },

    async fetchProducts(order_by = '') {
      let query = { exclusive: true };
      for (const key in this.filters) {
        if (this.filters[key] && this.filters[key].length > 0) {
          query[key] = this.filters[key];
        }
      }
      if (['discount','popular','cheap'].includes(order_by)) query.order_by = order_by;
      query.page = this.currentPage;

      try {
        const { data } = await axios.post('/api/products', query);
        this.totalPages = data.totalPages;
        this.products   = data.products;
      } catch (e) {
        console.error(e);
        alert('Ошибка при загрузке продуктов: ' + e.message);
      }
    },

    async fetchFilters() {
      try {
        const {data} = await axios.get('/api/filters?exclusive=true&category=null');
        this.brands = data.top_filters.brands; // массив строк
        await this.fetchProducts();
      } catch (e) {
        console.error(e);
      }
    },
    addToCart(productId) {

      let modalBasketAdd = document.querySelector('.modal-basket');

      cart.addItem(productId, 1).then(function (data) {
        let product_image = modalBasketAdd.querySelector('.product-image img');
        let product_name = modalBasketAdd.querySelector('a.product-name');
        let product_price_one = modalBasketAdd.querySelector('span.product-price');
        let product_desc = modalBasketAdd.querySelector('p.desc-cart-item');
        let item_active = data['cart_item']['item_active'];
        let quantity = item_active['quantity'];
        let price = item_active['price'];

        product_image.src = '/images/products/' + item_active.image;
        product_name.textContent = item_active.name;
        product_price_one.textContent = price + ' р';

        const wordForms = ['товар', 'товара', 'товаров'];
        const lastDigit = quantity % 10;
        const lastTwoDigits = quantity % 100;
        let wordForm
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
          wordForm = wordForms[2]; // "товаров"
        } else {
          if (lastDigit === 1) {
            wordForm = wordForms[0]; // "товар"
          } else if (lastDigit >= 2 && lastDigit <= 4) {
            wordForm = wordForms[1]; // "товара"
          } else {
            wordForm = wordForms[2]; // "товаров"
          }
        }
        // Перемножаем количество и цену и округляем до целого числа
        const totalPrice = Math.round(quantity * price);
        product_desc.textContent = 'В корзине ' + quantity + ' ' + wordForm + ' на сумму ' + totalPrice + ' р';

        modalBasketAdd.classList.add('activeModalBasket');
      }).catch(function (error) {
        console.error('Error adding item to cart:', error);
        this.showError('Ошибка при добавлении товара в корзину.');
      }.bind(this));

    },
  },
};
</script>

<style scoped>
.new-products-section {
  margin: 20px 0;
}
</style>